import React from 'react';
import {
  Paper,
  Card,
  Box,
  makeStyles,
  createStyles,
  Theme,
  Avatar,
  Typography,
  Chip,
  CardMedia,
  CardProps,
} from '@material-ui/core';
import { Button } from 'gatsby-theme-material-ui';
import { navigate } from 'gatsby';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
      minHeight: 378,
      // height: 378,
      display: 'flex',
      flexDirection: 'column',
    },
    coverImage: {
      height: 114,
    },
    avatar: {
      width: 100,
      height: 100,
      borderWidth: 4,
      borderColor: palette.primary.contrastText,
    },
    bottomContainer: {
      display: 'flex',
      flex: 1,
      alignItems: 'flex-end',
      margin: spacing(2),
    },
    row: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexGrow: 1,
    },
  })
);

interface Props extends CardProps {
  name: string;
  availableSpots: number;
  bio: string;
  price: number;
  profilePicture: string;
  coverImage: string;
  link?: string;
  hidePrice?: boolean;
}

export const TrainerCard: React.FC<Props> = ({
  name,
  profilePicture,
  coverImage,
  bio,
  price,
  availableSpots,
  link,
  hidePrice = false,
  ...props
}) => {
  const classes = useStyles();
  const handleCardClick = () => {
    trackCustomEvent({
      category: "Trainer Card",
      action: "Click",
      label: `${name}`,
      value: price
    })
    
    link && navigate(link);
  };
  return (
    <Card onClick={handleCardClick} className={classes.root} {...props}>
      <CardMedia className={classes.coverImage} image={coverImage} />
      <Box mt={-6.25} mx={2}>
        <Avatar alt={`${name} Profile Picture`} className={classes.avatar} src={profilePicture} />
      </Box>
      <Box display="flex" flexDirection="column" mx={2}>
        <Box mt={1.5} display="flex">
          <Typography variant="h6">{name}</Typography>
          <Box ml={1.5} />
          <Chip label="Verified" color="primary" />
        </Box>
        <Box mt={1.5}>
          <Typography variant="subtitle2">{`${availableSpots} Available Spots Left`}</Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="body1">{bio}</Typography>
        </Box>
      </Box>
      <Box className={classes.bottomContainer}>
        <Box className={classes.row}>
          {!hidePrice && (<Typography variant="subtitle1">{`CA$${price}/month`}</Typography>)}

          {link && (
            <Button to={link} color="primary">
              READ MORE
            </Button>
          )}
        </Box>
      </Box>
    </Card>
  );
};
